import {
    GET_DROPDOWN_OPTIONS_SUCCESS,
    GET_DROPDOWN_OPTIONS_FAILURE,
} from '../actions/actionTypes';

const initialState = {
    dropdownData: {},
};

const consignmentAddPriceOverrideReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_DROPDOWN_OPTIONS_SUCCESS:
            return {
                ...state,
                dropdownData: {
                    [action.payload.dropdownName]:
                        action.payload.dropdownOptions,
                },
            };
        case GET_DROPDOWN_OPTIONS_FAILURE:
            return {
                ...state,
                dropdownData: action.payload,
            };
            // return {
            //     ...state,
            //     dropdownData: {
            //         ...state.dropdownData,
            //         [action.payload.dropdownName]:
            //             action.payload.dropdownOptions,
            //     },
            // };
            
        default:
            return {
                ...state,
            };
    }
};

export default consignmentAddPriceOverrideReducer;
